'use strict';

const mutations = {};

export default mutations;
